import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Keep the application shell at 100% browser zoom. Feature-level image/design
// zoom controls use their own pointer handlers and remain unaffected.
const preventPageZoom = (event) => {
  if (event.ctrlKey && (["+", "-", "=", "0"].includes(event.key))) event.preventDefault();
};
window.addEventListener("keydown", preventPageZoom, { passive: false });
window.addEventListener("wheel", (event) => { if (event.ctrlKey) event.preventDefault(); }, { passive: false });
window.addEventListener("gesturestart", (event) => event.preventDefault(), { passive: false });

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
